import { useMemo } from 'react';
import { listIcons, listSpeedBands } from '../core';

/**
 * 内置水滴图标目录（同步，无需请求）
 * @param {{ enabled?: boolean }} opts
 */
export function useBuiltInIcons({ enabled = true } = {}) {
  const icons = useMemo(() => (enabled ? listIcons() : []), [enabled]);
  const speedBands = useMemo(() => (enabled ? listSpeedBands() : []), [enabled]);
  return {
    icons,
    speedBands,
    loading: false,
    error: null,
    reload: () => {}
  };
}
